// src/Components/Navbar.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleNavbar = () => setIsCollapsed(!isCollapsed);

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm" id='navbar'>
      <div className="container">
        {/* Logo */}
        <Link to="/" className="navbar-brand">
          <img
            src="/Photos/dfare.jpg"
            alt="Hosting Services"
            id="hostsky-img"
            width={200}
          />
        </Link>

        {/* Toggle for mobile */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar}
          aria-controls="navbarNav"
          aria-expanded={!isCollapsed}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible Menu */}
        <div
          className={`collapse navbar-collapse ${!isCollapsed ? 'show' : ''}`}
          id="navbarNav"
        >
          {/* Horizontal Nav Items */}
          <ul className="navbar-nav ms-auto d-flex align-items-center gap-3">
            <li className="nav-item">
              <Link to="/" className="nav-link" onClick={toggleNavbar}>Home</Link>
            </li>
            <li className="nav-item">
              <Link to="/about" className="nav-link" onClick={toggleNavbar}>About Us</Link>
            </li>
            <li className="nav-item">
              <Link to="/job" className="nav-link" onClick={toggleNavbar}>Jobs</Link>
            </li>
            <li className="nav-item">
              <Link to="/recruiting" className="nav-link" onClick={toggleNavbar}>Recruiting</Link>
            </li>
            <li className="nav-item">
              <Link to="/career" className="nav-link" onClick={toggleNavbar}>Career</Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link" onClick={toggleNavbar}>Contact Us</Link>
            </li>
          
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
